import * as yup from "yup";
import _ from "lodash";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import NotificationSuccess from "../notifications/agent-create.notification";
import NotificationError from "../notifications/agent-error.notification";
import { useAgentsAdminContext } from "../../../providers/agents-admin.provider";
import { useCreateAgent } from "../../../../../../services/microservice/admin/agents/use-agents-admin";

interface IFormValue {
  name: string;
  email: string;
  password: string;
  phoneNumber: string;
  role: any;
  active?: IActive;
  sponsor?: string;
}

interface IActive {
  name: string;
  value: boolean;
}

const formatData = (params: IFormValue) => {
  const { name, email, password, phoneNumber, role, sponsor } = params;
  const data = {};
  _.set(data, "name", name);
  _.set(data, "email", email);
  _.set(data, "password", password);
  _.set(data, "phone_number", phoneNumber);
  _.set(data, "roles", role._id);
  _.set(data, "sponsor", sponsor);
  return data as any;
};

const useAgentCreateFormUtil = () => {
  const { mutateAsync: createUser, isLoading } = useCreateAgent();
  const { sponsor } = useAgentsAdminContext();
  const navigate = useNavigate();

  const initialValues: IFormValue = {
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    role: {
      name: "",
      description: "",
      idSystem: "AGENT",
    },
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required(" Requerido"),
    password: yup
      .string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])([A-Za-z\d]|[^\w\s]){8,}$/,
        "La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial",
      ),
    email: yup
      .string()
      .email("Debes ingresar un correo electrónico válido")
      .required(" Requerido"),
    phoneNumber: yup
      .string()
      .matches(/^\d+$/, "El número de teléfono solo puede contener dígitos")
      .test(
        "len",
        "El número de teléfono debe tener exactamente 10 dígitos",
        (val) => val?.length === 10,
      )
      .required(" Requerido"),
    role: yup
      .object()
      .shape({
        name: yup.string(),
        description: yup.string(),
        idSystem: yup.string(),
      })
      .required(" Requerido"),
  });

  const submitForm = async (values: IFormValue) => {
    const data = formatData({ ...values, sponsor: sponsor.toUpperCase() });
    createUser(data)
      .then(() => {
        toast.success(<NotificationSuccess />);
        navigate(`/${sponsor}/admin/agents`, { replace: true });
      })
      .catch(() => toast.error(<NotificationError />));
  };

  return { initialValues, validationSchema, submitForm, isLoading };
};

export default useAgentCreateFormUtil;
